module.exports = __webpack_public_path__ + "static/media/КБП-Light.74b168a0.webp";